export default __webpack_public_path__ + "static/VIDA_GRUPO-378b3383b814dc9166338869346b52cc.png";